import { fmtEur, fmtPct } from "@/lib/format";

const pctStr = (v) => String(v).replace(".", ",");

export function TriCompare({ r }) {
  const triWins = r.tri !== null && r.tri >= r.rendementNet;
  const max = Math.max(Math.abs(r.tri ?? 0), Math.abs(r.rendementNet), 0.1);
  const items = [
    { k: "tri", label: `TRI sur fonds propres (${r.horizon} ans)`, v: r.tri, win: triWins },
    { k: "rendement", label: "Rendement net initial", v: r.rendementNet, win: !triWins },
  ];
  return (
    <div className="bg-[#1C1613] text-[#FFFFFF] rounded-2xl p-6 space-y-5 animate-fade-up" data-testid="tri-compare">
      {items.map((it) => (
        <div key={it.k}>
          <div className="flex items-end justify-between mb-2">
            <span className={`text-sm ${it.win ? "text-white font-semibold" : "text-[#D8CCBF]"}`}>{it.label}</span>
            <span data-testid={`tri-value-${it.k}`} className={`font-serif text-3xl font-semibold tabular-nums ${it.win ? "text-[#E9B65A]" : "text-[#D8CCBF]"}`}>
              {it.v === null ? "n.c." : fmtPct(it.v, 2)}
            </span>
          </div>
          <div className="h-2 w-full bg-white/10 rounded-full overflow-hidden">
            <div
              className={`animate-bar h-full rounded-full ${it.win ? "bg-[#C84C2C]" : "bg-[#8C7A70]"}`}
              style={{ width: `${Math.max(4, (Math.abs(it.v ?? 0) / max) * 100)}%` }}
            />
          </div>
        </div>
      ))}
      <p className="text-xs text-[#E6DDD4]/80 leading-relaxed">
        Rendement brut : {fmtPct(r.rendementBrut, 2)}. Le TRI intègre l'apport, le crédit, les loyers, la revente et l'impôt sur la plus-value.
      </p>
    </div>
  );
}

export const triHypotheses = (r) => {
  const h = r.hypotheses;
  return `Crédit de ${fmtEur(r.emprunt)} à ${pctStr(h.tauxCredit)} % sur ${pctStr(h.dureeCredit)} ans (hors assurance). Revalorisation ${pctStr(h.revalorisation)} %/an appliquée au prix hors frais (frais d'acquisition ${pctStr(h.fraisAcquisition)} %), loyers et charges indexés de ${pctStr(h.indexationLoyers)} %/an, frais de revente ${pctStr(h.fraisRevente)} %. Rendement net initial = (loyers − charges) / prix frais inclus. TRI calculé sur l'apport, avant impôt sur les revenus locatifs ; plus-value taxée selon les abattements pour durée de détention et la surtaxe légale. Estimations indicatives.`;
};
